import { useEffect, useState } from "react";
import { WifiSlash } from "@phosphor-icons/react";
import { getPreloadInfo } from "@/lib/offlinePreload";

const fmtHora = (ts) => {
  const d = new Date(ts);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export default function OfflineDataBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (online) return null;
  const info = getPreloadInfo();
  return (
    <div
      data-testid="offline-data-banner"
      style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", marginBottom: 14, background: "#FFFBEA", border: "1px solid #FFCC00", borderRadius: 4, fontSize: "0.82rem", color: "#3F3F46" }}
    >
      <WifiSlash size={18} weight="bold" />
      <div>
        <strong>Modo offline.</strong>{" "}
        {info
          ? <>Usando OS, equipes e itens salvos em <strong>{fmtHora(info.at)}</strong>. O apontamento fica na fila e sobe quando o sinal voltar.</>
          : <>Nenhum dado baixado ainda — abra o app com internet uma vez para preparar o modo offline.</>}
      </div>
    </div>
  );
}
